import { IEvent, IEventData, IEventsProvider } from '../types';
import { TAuthUser } from '../../../spa/store/general/types';
import { GA4_ID_LANGMAGIC, getGa4Id, isProduction } from '../../constants';

export class GoogleAnalyticsEventsProvider implements IEventsProvider {

  public setUser(user: TAuthUser): void {
    // gtag.js reads only gtag()'s `arguments` from dataLayer, a pushed plain array is ignored
    // @ts-ignore
    if (window.gtag) {
      // @ts-ignore
      const ids = isProduction() ? [getGa4Id(), GA4_ID_LANGMAGIC] : [getGa4Id()];
      for (const id of ids) {
        // @ts-ignore
        window.gtag('config', id, {
          user_id: user.hashId,
          send_page_view: false, // index.html's config already sent it
        });
      }
    }
  }

  public trackEvent(event: IEvent, date: Date, data: IEventData): void {
    // @ts-ignore
    if (window.gtag) {
      const eventName = event.subject + ': ' + event.action;
      // @ts-ignore
      window.gtag('event', eventName, data);
    }
  }

}
